module.exports = __webpack_public_path__ + "img/reactivations-preview.12f3aa36.jpg";